import React, { useEffect } from "react";
import Pagination from "react-bootstrap/Pagination";

const PaginationComponent = ({
    itemsCount,
    itemsPerPage,
    currentPage,
    setCurrentPage,
    pageClickHandler,
    alwaysShown = true,
    itemStyle = {},
    activeItemStyle = {},
    itemEvents = {}
}) => {
    const pagesCount = Math.ceil(itemsCount / itemsPerPage);
    const isPaginationShown = alwaysShown ? true : pagesCount > 1;
    const isCurrentPageFirst = currentPage === 1;
    const isCurrentPageLast = currentPage === pagesCount;

    const changePage = number => {
        if (currentPage === number) return;
        setCurrentPage(number);
        console.log('Owner CurrentPage: ' + currentPage);
    };

    const onPageNumberClick = pageNumber => {
        if (currentPage === pageNumber) {
            return;
        }
        else {
            setCurrentPage(pageNumber);
            pageClickHandler(pageNumber);
        }
    };

    const onPreviousPageClick = () => {
        changePage(currentPage => currentPage - 1);
        pageClickHandler(currentPage - 1);
    };

    const onNextPageClick = () => {
        changePage(currentPage => currentPage + 1);
        pageClickHandler(currentPage + 1);
    };

    const setLastPageAsCurrent = () => {
        if (currentPage > pagesCount) {
            setCurrentPage(pagesCount);
        }
    };

    let isPageNumberOutOfRange;

    const pageNumbers = [...new Array(pagesCount)].map((_, index) => {
        const pageNumber = index + 1;
        const isPageNumberFirst = pageNumber === 1;
        const isPageNumberLast = pageNumber === pagesCount;
        const isCurrentPageWithinTwoPageNumbers =
            Math.abs(pageNumber - currentPage) <= 9;

        //console.log('pageNumbers CurrentPage: ' + currentPage);

        if (
            isPageNumberFirst ||
            isPageNumberLast ||
            isCurrentPageWithinTwoPageNumbers
        ) {
            isPageNumberOutOfRange = false;
            return (
                <Pagination.Item
                    key={pageNumber}
                    onClick={() => onPageNumberClick(pageNumber)}
                    active={pageNumber === currentPage}
                    style={
                        pageNumber === currentPage
                            ? { ...itemStyle, ...activeItemStyle }
                            : itemStyle
                    }
                    {...itemEvents}
                >
                    {pageNumber}
                </Pagination.Item>
            );
        }

        if (!isPageNumberOutOfRange) {
            isPageNumberOutOfRange = true;
            return <Pagination.Ellipsis key={pageNumber} className="muted" disabled />;
        }

        return null;
    });

    useEffect(() => {
        const anchors = document.querySelectorAll(".pagination .page-link");
        anchors.forEach(a => {
            if (a.parentElement.classList.contains("active")) {
                Object.assign(a.style, itemStyle, activeItemStyle);
            } else {
                Object.assign(a.style, itemStyle);
            }
        });
    }, [itemStyle, activeItemStyle, currentPage]);

    useEffect(setLastPageAsCurrent, [pagesCount]);
    //useEffect(pageNumbers, [pagesCount]);

    return (
        <>
            {isPaginationShown && (
                <Pagination>
                    <Pagination.Prev
                        onClick={onPreviousPageClick}
                        disabled={isCurrentPageFirst}
                        style={itemStyle}
                        {...itemEvents}
                    />
                    {pageNumbers}
                    <Pagination.Next
                        onClick={onNextPageClick}
                        disabled={isCurrentPageLast}
                        style={itemStyle}
                        {...itemEvents}
                    />
                </Pagination>
            )}
        </>
    );
};

export default PaginationComponent;